import React from 'react';
import App from './App';
import ReactDOM from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from "@react-oauth/google";
import '@mantine/core/styles.css';
import { ProviderPlatforma } from './platforma';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <MantineProvider>
        <ProviderPlatforma>
          <App />
        </ProviderPlatforma>
      </MantineProvider>
    </GoogleOAuthProvider>
  </BrowserRouter>
);

if (process.env.REACT_APP_SERVER === '/') console.log = () => { };